import React from "react";
import Lars from "../Main/avataaars.svg"
import data from './data';


function Resources() {
  return (
    <div className="wrapper billboard">
       <div className="column-lg-12 row center">
        <div className="column column-md-6 column-lg-5">
          <img
            src={Lars}
            className="column-lg-12 hero-image"
            alt="Lars headshot"
          />
        </div>
        <div className="column column-lg-5 column-md-12 bio-container center billboard">
          <code>tl;dr</code>
          <h1>
            Lars Mackenzie creates {" "}
            <span className="highlight">resources</span>, too.{" "}
          </h1>
          <nav><a href="/#about">about</a><a href="/#skills">skills</a><a href="/#contact">contact</a><a href="/photography">photography</a><a href="/resources">resources</a></nav>
        </div>
      </div>

      <div className="row" id="scrolly">
        <div className="column">
       
        {data.map((item, i) => { 
          return (
            <div className="resource-item column center" key={i}>
              <h3>{item.title}</h3>
    
          <div className="row center">  <a className="tag" href={`resources/`+ item.slug}>View the resource</a></div>
     
           </div>
          )
        })}
        </div>
      </div>
    </div>
  );
}
export default Resources;
